import React from 'react';

const badgesData = [
  {
    icon: 'fas fa-clock',
    title: 'Plantão 24 Horas',
    description: 'Equipe preparada para deslocamento, diagnóstico e reparo em campo.',
  },
  {
    icon: 'fas fa-tractor',
    title: 'No Campo',
    description: 'Atendimento direto na sua propriedade rural.',
  },
  {
    icon: 'fas fa-microchip',
    title: 'Laboratório',
    description: 'Alta tecnologia em reparos eletrônicos agrícolas.',
  },
];

const Badges = () => {
  return (
    <div className="badges">
      {badgesData.map((badge, index) => (
        <div className="badge-card" key={index}>
          <i className={badge.icon}></i>
          <h3>{badge.title}</h3>
          <p>{badge.description}</p>
        </div>
      ))}
    </div>
  );
};

export default Badges;
